import { lazy } from "react";
import { Outlet } from "react-router-dom";
import DashboardLayout from "src/layouts/dashboard";

// ----------------------------------------------------------------------

const Page404 = lazy(() => import("src/pages/404"));

// ----------------------------------------------------------------------

export const mainRoutes = [
	{
		element: (
			<DashboardLayout>
				<Outlet />
			</DashboardLayout>
		),
		children: [{ path: "404", element: <Page404 /> }],
	},
];
